import { Tag, Tooltip } from '@surecompanies/core_components'
import React from 'react'
import type { AuditRun } from '../api/enrollment-overlap.types'
import { getDisplayStatus, type DisplayStatus } from '../utils/run-display'

const STATUS_LABEL: Record<DisplayStatus, string> = {
  RUNNING: 'Running',
  STALLED: 'Possibly stalled',
  SUCCEEDED: 'Succeeded',
  FAILED: 'Failed',
}

const STATUS_COLOR: Record<DisplayStatus, string> = {
  RUNNING: 'processing',
  STALLED: 'warning',
  SUCCEEDED: 'success',
  FAILED: 'error',
}

const STALLED_HINT =
  'This run has been running for more than 20 minutes. It is probably abandoned and will be marked as failed the next time an audit is triggered.'

interface RunStatusTagProps {
  run: Pick<AuditRun, 'status' | 'startedAt' | 'errorMessage'>
  /** Overridable for tests. */
  now?: number
}

export default function RunStatusTag({ run, now }: RunStatusTagProps) {
  const displayStatus = getDisplayStatus(run, now)
  const tag = (
    <Tag color={STATUS_COLOR[displayStatus]} data-testid="run-status-tag">
      {STATUS_LABEL[displayStatus]}
    </Tag>
  )

  if (displayStatus === 'FAILED' && run.errorMessage) {
    return <Tooltip title={run.errorMessage}>{tag}</Tooltip>
  }
  if (displayStatus === 'STALLED') {
    return <Tooltip title={STALLED_HINT}>{tag}</Tooltip>
  }
  return tag
}
